<template>
  <router-link :class="clases" :to="route">
    <font-awesome-icon  :icon="icon" size="4x" :style="{ color: 'white'}"  class="IconoOpcionMenu fLeft vAliMid"/>
    <div class="fLeft"><slot></slot></div>
    <div class="clear"></div>
  </router-link>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    route: {
      type: String,
      required: false,
      default: ""
    },
    tieneBordeInferior: {
      type: Boolean,
      required: false
    },
    tieneBordeSuperior: {
      type: Boolean,
      required: false
    }
  },
  name: 'GUILink',
  data(){
    return{
      clases: "OpcionMenu"
    }
  },
  mounted() {
    this.clases += this.tieneBordeInferior ? " BordeInferior" : "";
    this.clases += this.tieneBordeSuperior ? " BordeSuperior" : "";
  }
}
</script>

<style scoped>
  .OpcionMenu{
    width:100%;
    height:60px;
    line-height:60px;
    color:white;
    display:block;
    cursor:pointer;
  }
  .OpcionMenu:hover{
    background-color: rgba(255,255,255,0.1) !important; }
  .IconoOpcionMenu{
    width:26px; 
    height:26px;
    margin:17px;
  }
  .BordeSuperior{
    border-top:1px solid rgba(255,255,255,0.2);
  }
  .BordeInferior{
    border-bottom:1px solid rgba(255,255,255,0.2);
  }
</style>